
export const SALES_SCRIPTS = [
    {
        id: "vsl-curta",
        title: { pt: "VSL Curta (Video Sales Letter)", en: "Short VSL", es: "VSL Corta" },
        tags: ["Vendas", "Marketing", "Conversão"],
        content: {
            pt: `<r>PROMESSA (0-30s)</r>
Nos próximos 90 segundos, eu vou te mostrar como você pode [RESULTADO DESEJADO] sem precisar [DOR/OBJEÇÃO].
Se você já tentou de tudo e nada funcionou, a culpa não é sua.
O problema é que a indústria tradicional esconde O REAL SEGREDO de você.
<y>MECANISMO ÚNICO (30-60s)</r>
Eu descobri um método chamado [NOME DO MÉTODO] que foca em [DIFERENCIAL].
Enquanto todos estão fazendo [VELHO JEITO], nós estamos obtendo [RESULTADO] fazendo exatamente o oposto.
Foi assim que o [CLIENTE X] conseguiu [RESULTADO] em apenas [TEMPO].
<y>OFERTA (60-90s)</r>
Eu compilei todo esse conhecimento no [NOME DO PRODUTO].
Ele não é apenas um curso, é um sistema completo.
E hoje, você pode ter acesso com [DESCONTO] de desconto.
<g>CTA</r>
Mas atenção: essa oferta só vale até [PRAZO/ESCASSEZ].
Clique no botão abaixo agora e garanta sua vaga.`,
            en: `<r>PROMISE (0-30s)</r>
In the next 90 seconds, I will show you how you can [DESIRED RESULT] without needing to [PAIN/OBJECTION].
If you've tried everything and nothing worked, it's not your fault.
The problem is that the traditional industry hides THE REAL SECRET from you.
<y>UNIQUE MECHANISM (30-60s)</r>
I discovered a method called [METHOD NAME] that focuses on [DIFFERENTIATOR].
While everyone is doing [OLD WAY], we are getting [RESULT] by doing exactly the opposite.
That's how [CLIENT X] achieved [RESULT] in just [TIME].
<y>OFFER (60-90s)</r>
I compiled all this knowledge into [PRODUCT NAME].
It's not just a course, it's a complete system.
And today, you can get access with [DISCOUNT] off.
<g>CTA</r>
But attention: this offer is only valid until [DEADLINE/SCARCITY].
Click the button below now and secure your spot.`,
            es: `<r>PROMESA (0-30s)</r>
En los próximos 90 segundos, te mostraré cómo puedes [RESULTADO DESEADO] sin necesidad de [DOLOR/OBJECIÓN].
Si ya has intentado todo y nada funcionó, no es tu culpa.
El problema es que la industria tradicional te esconde EL SECRETO REAL.
<y>MECANISMO ÚNICO (30-60s)</r>
Descubrí un método llamado [NOMBRE DEL MÉTODO] que se enfoca en [DIFERENCIAL].
Mientras todos están haciendo [VIEJA FORMA], nosotros estamos obteniendo [RESULTADO] haciendo exactamente lo opuesto.
Así fue como [CLIENTE X] consiguió [RESULTADO] en solo [TIEMPO].
<y>OFERTA (60-90s)</r>
He recopilado todo este conocimiento en [NOMBRE DEL PRODUCTO].
No es solo un curso, es un sistema completo.
Y hoy, puedes tener acceso con [DESCUENTO] de descuento.
<g>CTA</r>
Pero atención: esta oferta solo es válida hasta [PLAZO/ESCASEZ].
Haz clic en el botón de abajo ahora y asegura tu lugar.`
        }
    },
    {
        id: "ad-interrupt",
        title: { pt: "Interrupt Ad (Anúncio de Interrupção)", en: "Interrupt Ad", es: "Anuncio de Interrupción" },
        tags: ["Vendas", "Ads", "Tráfego Pago"],
        content: {
            pt: `<r>INTERRUPÇÃO (3s)</r>
Pare de rolar!
Se você é [PÚBLICO ALVO], você precisa ver isso.
<y>AGITAÇÃO DO PROBLEMA (10s)</r>
Você está cansado de gastar dinheiro com [SOLUÇÃO RUIM] e não ter retorno?
Eu sei como é. Parece que você está jogando dinheiro no lixo.
<y>A SOLUÇÃO (10s)</r>
Mas e se eu te dissesse que existe uma nova forma de [BENEFÍCIO]?
Apresentando o [SEU PRODUTO].
<g>CTA (7s)</r>
Toque em "Saiba Mais" para ver como funciona. É grátis (por enquanto).`,
            en: `<r>INTERRUPTION (3s)</r>
Stop scrolling!
If you are [TARGET AUDIENCE], you need to see this.
<y>PROBLEM AGITATION (10s)</r>
Are you tired of wasting money on [BAD SOLUTION] and getting no return?
I know how it feels. It looks like you're throwing money away.
<y>THE SOLUTION (10s)</r>
But what if I told you there is a new way to [BENEFIT]?
Introducing [YOUR PRODUCT].
<g>CTA (7s)</r>
Tap "Learn More" to see how it works. It's free (for now).`,
            es: `<r>INTERRUPCIÓN (3s)</r>
¡Deja de hacer scroll!
Si eres [PÚBLICO OBJETIVO], necesitas ver esto.
<y>AGITACIÓN DEL PROBLEMA (10s)</r>
¿Estás cansado de gastar dinero con [MALA SOLUCIÓN] y no tener retorno?
Sé cómo se siente. Parece que estás tirando dinero a la basura.
<y>LA SOLUCIÓN (10s)</r>
¿Pero y si te dijera que existe una nueva forma de [BENEFICIO]?
Presentando el [TU PRODUCTO].
<g>CTA (7s)</r>
Toca en "Más Información" para ver cómo funciona. Es gratis (por ahora).`
        }
    },
    {
        id: "sales-story-sell",
        title: { pt: "Venda com História (Jornada do Herói)", en: "Story Selling", es: "Venta con Historia" },
        tags: ["Vendas", "Storytelling", "Soft Sell"],
        content: {
            pt: `<r>O INÍCIO HUMILDE</r>
Há 3 anos, eu estava exatamente onde você está hoje.
Frustrado, sem dinheiro e sem esperança.
<y>A MUDANÇA</r>
Foi aí que eu decidi testar algo radical.
Em vez de seguir a manada, eu criei meu próprio caminho.
Todo mundo me chamou de louco.
<y>O RESULTADO</r>
Mas os resultados falaram mais alto. Em 30 dias, eu fiz [RESULTADO].
Não foi sorte. Foi método.
<g>O CONVITE</r>
Eu quero te ensinar esse mesmo método.
Eu preparei uma aula gratuita explicando tudo.
O link está na bio. Te vejo lá.`,
            en: `<r>THE HUMBLE START</r>
3 years ago, I was exactly where you are today.
Frustrated, broke, and hopeless.
<y>THE CHANGE</r>
That's when I decided to try something radical.
Instead of following the herd, I created my own path.
Everyone called me crazy.
<y>THE RESULT</r>
But the results spoke louder. In 30 days, I made [RESULT].
It wasn't luck. It was a method.
<g>THE INVITE</r>
I want to teach you this exact method.
I prepared a free class explaining everything.
The link is in the bio. See you there.`,
            es: `<r>EL INICIO HUMILDE</r>
Hace 3 años, estaba exactamente donde estás tú hoy.
Frustrado, sin dinero y sin esperanza.
<y>EL CAMBIO</r>
Ahí fue cuando decidí probar algo radical.
En lugar de seguir a la manada, creé mi propio camino.
Todos me llamaron loco.
<y>EL RESULTADO</r>
Pero los resultados hablaron más fuerte. En 30 días, hice [RESULTADO].
No fue suerte. Fue método.
<g>LA INVITACIÓN</r>
Quiero enseñarte este mismo método.
Preparé una clase gratuita explicando todo.
El enlace está en la bio. Nos vemos allá.`
        }
    },
    {
        id: "sales-webinar-invite",
        title: { pt: "Convite para Webinar/Live", en: "Webinar Invite", es: "Invitación a Webinar" },
        tags: ["Vendas", "Lançamento", "Evento"],
        content: {
            pt: `<r>PERGUNTA PROVOCATIVA</r>
Você sabe qual é o erro nº 1 que impede [PÚBLICO] de ganhar [OBJETIVO]?
Eu vou revelar a resposta ao vivo.
<y>O EVENTO</r>
Na próxima quinta-feira, às 20h, vou fazer uma Masterclass exclusiva sobre [TEMA].
Vou abrir a caixa preta da minha operação e mostrar:
- Segredo 1
- Segredo 2
- E como [BENEFÍCIO]
<g>CTA</r>
As vagas são limitadas pelo Zoom.
Se cadastre agora no botão abaixo para garantir seu lugar.`,
            en: `<r>PROVOCATIVE QUESTION</r>
Do you know what is the #1 mistake stopping [AUDIENCE] from earning [GOAL]?
I will reveal the answer live.
<y>THE EVENT</r>
Next Thursday at 8 PM, I'm hosting an exclusive Masterclass on [TOPIC].
I'll open the black box of my operation and show:
- Secret 1
- Secret 2
- And how to [BENEFIT]
<g>CTA</r>
Spots are limited by Zoom.
Register now at the button below to secure your place.`,
            es: `<r>PREGUNTA PROVOCATIVA</r>
¿Sabes cuál es el error nº 1 que impide a [PÚBLICO] ganar [OBJETIVO]?
Revelaré la respuesta en vivo.
<y>EL EVENTO</r>
El próximo jueves a las 20h, haré una Masterclass exclusiva sobre [TEMA].
Abriré la caja negra de mi operación y mostraré:
- Secreto 1
- Secreto 2
- Y cómo [BENEFICIO]
<g>CTA</r>
Los cupos son limitados por Zoom.
Regístrate ahora en el botón de abajo para asegurar tu lugar.`
        }
    },
    {
        id: "sales-flash-offer",
        title: { pt: "Oferta Relâmpago (Flash Sale)", en: "Flash Sale Offer", es: "Oferta Relámpago" },
        tags: ["Vendas", "Promoção", "Urgência"],
        content: {
            pt: `<r>URGÊNCIA MÁXIMA</r>
Para tudo! O que eu vou falar agora vai durar apenas 24 horas.
O [PRODUTO] que você tanto queria entrou em OFERTA RELÂMPAGO.
<y>O DESCONTO</r>
De [PREÇO ORIGINAL] por apenas [PREÇO PROMOCIONAL].
É menos que o preço de uma pizza.
Mas atenção: quando o relógio bater meia-noite, o preço volta ao normal.
<g>CTA</r>
Não perde essa. O link está aqui. Corre!`,
            en: `<r>MAX URGENCY</r>
Stop everything! What I'm about to say will last only 24 hours.
The [PRODUCT] you wanted so much just went on FLASH SALE.
<y>THE DISCOUNT</r>
From [ORIGINAL PRICE] for only [PROMO PRICE].
It's less than the price of a pizza.
But attention: when the clock strikes midnight, the price goes back to normal.
<g>CTA</r>
Don't miss this. The link is here. Run!`,
            es: `<r>URGENCIA MÁXIMA</r>
¡Para todo! Lo que voy a decir ahora durará solo 24 horas.
El [PRODUCTO] que tanto querías acaba de entrar en OFERTA RELÁMPAGO.
<y>EL DESCUENTO</r>
De [PRECIO ORIGINAL] por solo [PRECIO PROMOCIONAL].
Es menos que el precio de una pizza.
Pero atención: cuando el reloj marque medianoche, el precio vuelve a la normalidad.
<g>CTA</r>
No te pierdas esto. El enlace está aquí. ¡Corre!`
        }
    },
    {
        id: "sales-testimonial-case",
        title: { pt: "Estudo de Caso / Depoimento", en: "Case Study / Testimonial", es: "Estudio de Caso / Testimonio" },
        tags: ["Vendas", "Prova Social", "Credibilidade"],
        content: {
            pt: `<r>O PROBLEMA</r>
A [NOME DO CLIENTE] tinha um grande problema: [PROBLEMA].
Ela tentou [SOLUÇÃO A], tentou [SOLUÇÃO B], e nada.
Ela estava quase desitindo.
<y>A VIRADA</r>
Foi quando ela conheceu o [SEU PRODUTO].
Em apenas 2 semanas, ela conseguiu [RESULTADO INCRÍVEL].
Olha o que ela disse:
"[INSERIR FRASE DO DEPOIMENTO]"
<g>APLICAÇÃO</r>
Você pode ter o mesmo resultado.
Se você quer parar de sofrer com [PROBLEMA], clique aqui.`,
            en: `<r>THE PROBLEM</r>
[CLIENT NAME] had a big problem: [PROBLEM].
She tried [SOLUTION A], tried [SOLUTION B], and nothing.
She was almost giving up.
<y>THE TURNING POINT</r>
That's when she met [YOUR PRODUCT].
In just 2 weeks, she achieved [AMAZING RESULT].
Look what she said:
"[INSERT TESTIMONIAL QUOTE]"
<g>APPLICATION</r>
You can have the same result.
If you want to stop suffering with [PROBLEM], click here.`,
            es: `<r>EL PROBLEMA</r>
[NOMBRE DEL CLIENTE] tenía un gran problema: [PROBLEMA].
Intentó [SOLUCIÓN A], intentó [SOLUCIÓN B], y nada.
Estaba casi rindiéndose.
<y>EL CAMBIO</r>
Fue cuando conoció [TU PRODUCTO].
En solo 2 semanas, consiguió [RESULTADO INCREÍBLE].
Mira lo que dijo:
"[INSERTAR FRASE DEL TESTIMONIO]"
<g>APLICACIÓN</r>
Tú puedes tener el mismo resultado.
Si quieres dejar de sufrir con [PROBLEMA], haz clic aquí.`
        }
    },
    {
        id: "sales-objection-killer",
        title: { pt: "Quebra de Objeção (Caro?)", en: "Objection Killer (Too Expensive?)", es: "Rompe Objeciones (¿Caro?)" },
        tags: ["Vendas", "Objeção", "Lógica"],
        content: {
            pt: `<r>PERGUNTA DIRETA</r>
Você acha que [PREÇO] é caro?
Eu entendo. Mas deixa eu te fazer uma pergunta.
<y>O CUSTO DA INAÇÃO</r>
Quanto custa para você continuar com [PROBLEMA]?
Quanto você perde por mês por não saber [HABILIDADE]?
Provavelmente muito mais que [PREÇO].
<y>INVESTIMENTO</r>
Isso não é um gasto, é um investimento.
Se esse curso te ajudar a fechar apenas 1 cliente, ele já se paga.
<g>GARANTIA</r>
E se você não gostar, eu devolvo seu dinheiro.
O risco é zero. Bora?`,
            en: `<r>DIRECT QUESTION</r>
Do you think [PRICE] is expensive?
I understand. But let me ask you a question.
<y>COST OF INACTION</r>
How much does it cost you to continue with [PROBLEM]?
How much do you lose per month by not knowing [SKILL]?
Probably much more than [PRICE].
<y>INVESTMENT</r>
This is not an expense, it's an investment.
If this course helps you close just 1 client, it pays for itself.
<g>GUARANTEE</r>
And if you don't like it, I refund your money.
The risk is zero. Let's go?`,
            es: `<r>PREGUNTA DIRECTA</r>
¿Crees que [PRECIO] es caro?
Lo entiendo. Pero déjame hacerte una pregunta.
<y>COSTO DE LA INACCIÓN</r>
¿Cuánto te cuesta continuar con [PROBLEMA]?
¿Cuánto pierdes al mes por no saber [HABILIDAD]?
Probablemente mucho más que [PRECIO].
<y>INVERSIÓN</r>
Esto no es un gasto, es una inversión.
Si este curso te ayuda a cerrar solo 1 cliente, ya se paga solo.
<g>GARANTÍA</r>
Y si no te gusta, te devuelvo tu dinero.
El riesgo es cero. ¿Vamos?`
        }
    },
    {
        id: "sales-faq-close",
        title: { pt: "FAQ de Fechamento", en: "Closing FAQ", es: "FAQ de Cierre" },
        tags: ["Vendas", "Fechamento", "Dúvidas"],
        content: {
            pt: `<r>INTRO</r>
As inscrições estão acabando e muita gente me mandou perguntas.
Vou responder as principais agora.
<y>PERGUNTAS</r>
1. "Serve para iniciantes?"
Sim! Começamos do absoluto zero.
2. "Tenho garantia?"
Sim, 7 dias incondicional.
3. "Quanto tempo de acesso?"
Acesso vitalício!
<g>ULTIMATO</r>
Não deixe suas dúvidas te impedirem de crescer.
Te vejo dentro da área de membros!`,
            en: `<r>INTRO</r>
Registrations are closing and many people sent me questions.
I'll answer the main ones now.
<y>QUESTIONS</r>
1. "Is it for beginners?"
Yes! We start from absolute zero.
2. "Do I have a guarantee?"
Yes, 7 days unconditional.
3. "How long is the access?"
Lifetime access!
<g>ULTIMATUM</r>
Don't let your doubts stop you from growing.
See you inside the member area!`,
            es: `<r>INTRO</r>
Las inscripciones se están acabando y mucha gente me envió preguntas.
Responderé las principales ahora.
<y>PREGUNTAS</r>
1. "¿Sirve para principiantes?"
¡Sí! Empezamos desde cero absoluto.
2. "¿Tengo garantía?"
Sí, 7 días incondicional.
3. "¿Cuánto tiempo de acceso?"
¡Acceso de por vida!
<g>ULTIMÁTUM</r>
No dejes que tus dudas te impidan crecer.
¡Nos vemos dentro del área de miembros!`
        }
    }
];
